import * as defaultNotificationBar from '../config/configNotificationBar';

const getDataNotificationBar = config => {
  // Sharetribe disconnect: this used to come exclusively from the hosted
  // notificationBar.json asset, which can no longer be fetched -- fall
  // back to the local Coachify defaults instead of showing nothing. The
  // old isDisplayNotificationBarFromFlexConsole toggle only ever existed
  // to let a Console admin enable/disable the hosted bar; with no hosted
  // config left to toggle, the local fallback is just always on.
  if (!config?.notificationBar) {
    return {
      isDisplayNotificationBarFromFlexConsole: true,
      backgroundColor: defaultNotificationBar.backgroundColor,
      textColor: defaultNotificationBar.textColor,
      contentTitle: defaultNotificationBar.contentTitle,
      contentCallToAction: defaultNotificationBar.contentCallToAction,
      hrefCallToAction: defaultNotificationBar.hrefCallToAction,
    };
  }

  const notificationBarData = config.notificationBar?.sections?.[0] || {};

  const {
    appearance: { backgroundColor, textColor } = {},
    title: { content: contentTitle = '' } = {},
    callToAction: {
      content: contentCallToAction = '',
      href: hrefCallToAction = '',
    } = {},
    blocks = [],
  } = notificationBarData;

  const isDisplayNotificationBarFromFlexConsole =
    blocks[0]?.title?.content === 'true' ? true : false;

  return {
    isDisplayNotificationBarFromFlexConsole,
    backgroundColor,
    textColor,
    contentTitle,
    contentCallToAction,
    hrefCallToAction,
  };
};

export default getDataNotificationBar;
